// import OpenAI from 'openai'

// const key = process.env.REACT_APP_OPEN_AI_API_KEY

// const openai = new OpenAI({
//     dangerouslyAllowBrowser: true,
//     apiKey: key,
// })

// if (!key) {
//     throw new Error('Please set your OpenAI API key in the environment variable OPENAI_API_KEY')
// }

// role:'system' is not required in the messages array, but it can be used to set the context for the conversation.
// another ie for role system: 'you are a rap genius' if the quetions would be about rap music
// role:'user' is the user input, and role:'assistant' is the AI response.

// const messages = [
//     {
//         role: 'system',
//         content: 'You are a helpful general knowledge expert.'
//     },
//     {
//         role: 'user',
//         content: 'Who invented the television?'
//     }
// ]

// const response = await openai.chat.completions.create({
//     model: 'gpt-4.1-nano',
//     messages: messages
// })

// console.log(response);

const messages = [
    {
        role: 'system',
        content: 'You are a helpful Vinyl records and music expert. Only answer questions about music and vinyl records.'
    },
    {
        role: 'user',
        content: 'How many versions of the Suffocation album "Pierced from within" are there?'
    }
]

const url = 'https://openai-api-worker.hisham-abi-farah.workers.dev/'

const response = await fetch(url, {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify(messages)
})
const data = await response.json()


if (!response.ok) {
    throw new Error(`Worker Error: ${data.error}`)
}

console.log(data)

const Test = () => {
    return (
        <div>
            <h1>Check the console for OpenAI response</h1>
        </div>
    )
}


export default Test